<script lang="ts">
	import { getHubStores } from '$lib/stores/hubStores';
	import Avatar from '$lib/components/Avatar/Avatar.svelte';
	import Popover from '$lib/components/Popover/Popover.svelte';
	import UserPVcard from '$lib/components/UserPVCard/userPVcard.svelte';
	import CounterPill from '$lib/components/cover/usersContainer/CounterPill.svelte';
	import type { Writable } from 'svelte/store';
	import type { Hub } from '$lib/api/rpc';

	export let hub: Writable<Hub>;
	const { collaborators } = getHubStores();
</script>

<div class="px-cover-collaborators">
	{#if $collaborators.length && $hub.user_context.perms.team.view.collaborators}
		<div class="collaboratorsIcons">
			{#each $collaborators as user}
				{#if $hub.user_context.perms.team.open_user_popup}
					<Popover position="bottom-inline-end">
						<Avatar url={user.avatar_url || ''} name={user.name} slot="target" />
						<UserPVcard {user} slot="content" />
					</Popover>
				{:else}
					<Avatar url={user.avatar_url || ''} name={user.name} />
				{/if}
			{/each}
		</div>
	{/if}
	<CounterPill {hub} />
</div>

<style>
	.px-cover-collaborators {
		display: flex;
		align-items: center;
		justify-content: center;
		block-size: auto;
		margin: var(--gutterMedium);
	}

	.collaboratorsIcons {
		display: flex;
		z-index: var(--z-index-Collaborators-icons);
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;
		min-inline-size: 130px;
		gap: var(--gutterMedium);
		row-gap: var(--gutterSmaller);
	}
</style>
